import { APP_LANGUAGES } from "@/i18n/types/app-languages.types";
import type { TFunction } from "i18next";
import * as z from "zod";

export const userProfileFormSchema = (t: TFunction) => {
  return z.object({
    firstName: z.string().min(2, {
      message: t("firstname_min_length"),
    }),
    lastName: z.string().min(2, {
      message: t("lastname_min_length"),
    }),
    avatarUrl: z.string().nullable(),
    preferredLanguage: z.enum(APP_LANGUAGES, {
      message: t("language_required"),
    }),
    deleteAvatar: z.boolean(),
    file: z.instanceof(File).optional(),
  });
};

export type UserProfileFormValues = z.infer<
  ReturnType<typeof userProfileFormSchema>
>;
